exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".alert {\n  padding: .7143rem 1.071rem;\n  margin-bottom: 1.429rem;\n  border-radius: 2px;\n  border: 1px solid transparent;\n  color: #FFF; }\n\n.alert.alert-square {\n  border-radius: 0; }\n\n.alert .close {\n  position: relative; }\n\n.alert.alert-dismissable,\n.alert.alert-dismissible {\n  padding-right: 2.5rem; }\n\n.alert.alert-dismissable .close,\n.alert.alert-dismissible .close {\n  top: -2px;\n  right: -20px;\n  color: inherit;\n  float: right;\n  cursor: pointer; }\n\n.alert.primary {\n  background-color: #2196F3;\n  border-color: #2196F3; }\n\n.alert.secondary {\n  background-color: #323a45;\n  border-color: #323a45; }\n\n.alert.success {\n  background-color: #64DD17;\n  border-color: #64DD17; }\n\n.alert.info {\n  background-color: #29B6F6;\n  border-color: #29B6F6; }\n\n.alert.warning {\n  background-color: #FFC107;\n  border-color: #FFC107; }\n\n.alert.danger {\n  background-color: #ef1c1c;\n  border-color: #EF5350; }\n\n.close-alert {\n  display: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/alert-text/alert-text.component.scss
// module id = 2156
// module chunks = 66